import { useEffect } from 'react';

import { VIEWS } from '../constants';

export function useViewDataLoading({
  adminUsers,
  appDataLoaded,
  handleOpenJiraAuthors,
  loadAbsences,
  loadAdminUsers,
  loadDealViews,
  loadDeals,
  loadTenders,
  loadContacts,
  loadJiraData,
  loadJiraImportLogs,
  loadHoursByBrick,
  loadLateHours,
  loadLeaveMovements,
  loadTimesheetMonth,
  loadUserAbsences,
  profile,
  session,
  appState,
  timesheetUserId,
  timesheetMonth,
}) {
  useEffect(() => {
    if (session && profile && appState.view === VIEWS.TIMESHEETS) {
      loadTimesheetMonth(timesheetMonth, timesheetUserId);
      if (profile.role === 'manager' && adminUsers.length === 0) loadAdminUsers();
      if (profile.role === 'manager') loadJiraImportLogs();
    }
    if (session && profile && (appState.view === VIEWS.PROFILE || appState.view === VIEWS.LEAVE))
      loadUserAbsences();
    if (session && profile && [VIEWS.TEAM, VIEWS.LEAVE].includes(appState.view))
      loadLeaveMovements();
    if (
      session &&
      profile &&
      [VIEWS.TIMELINE, VIEWS.TEAM, VIEWS.PROFILE, VIEWS.TIMESHEETS, VIEWS.LEAVE].includes(
        appState.view,
      )
    )
      loadAbsences();
    if (session && profile && appState.view === VIEWS.PROJECTS) {
      loadHoursByBrick(appState.clients);
      loadJiraData();
      // Affaires et lignes : la fiche projet en a besoin (dates reportées sur la ligne, affaire
      // passée en Terminé à la clôture, suppression d'une phase convertie).
      loadDeals();
      // Phases terminées qui reçoivent encore des heures (alerte de fin de phase).
      loadLateHours();
    }
    if (session && profile && appState.view === VIEWS.TIMELINE) loadJiraData(); // conso Jira pour la vue Par projet
    if (session && profile && appState.view === VIEWS.JIRA) {
      if (profile.role === 'manager' && adminUsers.length === 0) loadAdminUsers();
      if ((appState.clients || []).length > 0) handleOpenJiraAuthors();
      loadJiraImportLogs();
    }
    if (session && profile && (appState.view || '').startsWith('crm')) {
      if (profile.role === 'manager' && adminUsers.length === 0) loadAdminUsers();
      loadDeals();
      loadDealViews();
      if (appState.view === VIEWS.CRM_CONTACTS) loadContacts();
      if (appState.view === VIEWS.CRM_TENDERS) loadTenders();
    }
  }, [session, profile, appState.view, timesheetMonth, timesheetUserId, appDataLoaded]);
}
